var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGift6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30.0 30.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,900 L0,900 L0,0 L375,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C23.2842712,-1.52179594e-15 30,6.71572875 30,15 C30,23.2842712 23.2842712,30 15,30 C6.71572875,30 1.01453063e-15,23.2842712 0,15 C-1.01453063e-15,6.71572875 6.71572875,1.52179594e-15 15,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7670538,0 C12.8915515,0 12.9924768,0.100925289 12.9924768,0.225422943 L12.9924768,7.54197541 C12.9911137,8.05056861 12.5790904,8.46249118 12.0704969,8.46372983 L0.921979838,8.46372983 C0.41338632,8.46249118 0.00136301491,8.05056861 0,7.54197541 L0,0.225422943 C0,0.100925289 0.100925289,0 0.225422943,0 L12.7670538,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i3",
    x1: "19.1408134px",
    y1: "-5.51017949px",
    x2: "-2.67862876px",
    y2: "9.93167858px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.090785,0 L12.090785,7.09112952 C12.0905367,7.35126321 11.8797846,7.56211615 11.619651,7.5624889 L0.471359374,7.5624889 C0.211137798,7.56224036 0.000248540357,7.3513511 0,7.09112952 L0,0 L12.090785,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i5",
    x1: "-5.14448759px",
    y1: "0px",
    x2: "17.8853291px",
    y2: "6.1386349px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2056792,0 C15.5224593,0.0002484306 15.7792331,0.25692144 15.779606,0.57370139 L15.779606,2.31622074 C15.7789848,2.6328246 15.5222836,2.88922338 15.2056792,2.88947129 L0.573926813,2.88947129 C0.257322445,2.88922338 0.000621183293,2.6328246 0,2.31622074 L0,0.57370139 C0.000372877668,0.25692144 0.257146741,0.0002484306 0.573926813,0 L15.2056792,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7548333,0 C14.8227211,0 14.8779143,0.0549678348 14.8779143,0.122855504 L14.8779143,1.86537485 C14.8779143,1.93326252 14.8227211,1.98823036 14.7548333,1.98823036 L0.123080927,1.98823036 C0.0551931439,1.98823036 0,1.93326252 0,1.86537485 L0,0.122855504 C0,0.0549678348 0.0551931439,0 0.123080927,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i8",
    x1: "0px",
    y1: "-4.50626363px",
    x2: "16.7326047px",
    y2: "5.5866118px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7952445,0 C2.91974215,0 3.02066744,0.108120619 3.02066744,0.241494162 L3.02066744,8.82564565 C3.02066744,8.95901919 2.91974215,9.06713981 2.7952445,9.06713981 L0.225422943,9.06713981 C0.100925289,9.06713981 0,8.95901919 0,8.82564565 L0,0.241494162 C0,0.108120619 0.100925289,0 0.225422943,0 L2.7952445,0 Z M2.56982155,0.392244424 L0.450845886,0.392244424 L0.450845886,8.64800782 L2.56982155,8.64800782 L2.56982155,0.392244424 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.03921921,0.0980598596 L3.73511792,2.35829715 C3.85994738,2.46295398 3.87630053,2.64898937 3.77164371,2.77381882 C3.76056006,2.78703884 3.74833794,2.79926097 3.73511792,2.81034461 C3.65116687,2.88072904 3.54654289,2.91322359 3.44350359,2.90782827 C3.44087286,2.96637328 3.41841319,3.02524604 3.3770644,3.07456482 C3.36598076,3.08778484 3.35375864,3.10000696 3.34053862,3.1110906 L0.644639906,5.3713279 C0.488692003,5.50207437 0.261408067,5.50207437 0.105460164,5.3713279 C-0.019369295,5.26667107 -0.0357224462,5.08063568 0.0689343781,4.95580622 C0.0800180229,4.9425862 0.0922401431,4.93036408 0.105460164,4.91928044 L2.80135887,2.65904315 C2.84012885,2.62653845 2.88330784,2.60211471 2.92870361,2.5857719 L0.500039468,0.550107318 C0.375210009,0.445450494 0.358856858,0.259415104 0.463513682,0.134585645 C0.474597327,0.121365625 0.486819447,0.109143504 0.500039468,0.0980598596 C0.655987371,-0.0326866199 0.883271307,-0.0326866199 1.03921921,0.0980598596 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i11",
    x1: "5.9776128px",
    y1: "-1.67547739px",
    x2: "-2.8381421px",
    y2: "9.88174805px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A77",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-332.0 -747.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 215.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 494.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.0 13.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(231.35388698072165 25.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.6461130192783457 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 30,0 30,30 0,30 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.0 6.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.3935646348181763 6.745469009441052)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 12.9924768,0 12.9924768,8.46372983 0,8.46372983 0,0",
    stroke: "none",
    fill: "url(#i3)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.844410521204865 7.196314895827092)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 12.090785,0 12.090785,7.5624889 0,7.5624889 0,0",
    stroke: "none",
    fill: "url(#i5)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 4.306843609979511)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 15.779606,0 15.779606,2.88947129 0,2.88947129 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.45084588638668954 4.757689496365551)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 14.8779143,0 14.8779143,1.98823036 0,1.98823036 0,0",
    stroke: "none",
    fill: "url(#i8)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.37946929236043 6.837030464359648)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i9)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 3.02066744,0 3.02066744,9.06713981 0,9.06713981 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.121944563508261 0.605946592953547) rotate(90.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i10)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "2.70179712e-12,1.61071156e-12 3.84057808,1.61071156e-12 3.84057808,5.46938776 2.70179712e-12,5.46938776 2.70179712e-12,1.61071156e-12",
    stroke: "none",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.03921921,0.0980598596 L3.73511792,2.35829715 C3.85994738,2.46295398 3.87630053,2.64898937 3.77164371,2.77381882 C3.76056006,2.78703884 3.74833794,2.79926097 3.73511792,2.81034461 C3.65116687,2.88072904 3.54654289,2.91322359 3.44350359,2.90782827 C3.44087286,2.96637328 3.41841319,3.02524604 3.3770644,3.07456482 C3.36598076,3.08778484 3.35375864,3.10000696 3.34053862,3.1110906 L0.644639906,5.3713279 C0.488692003,5.50207437 0.261408067,5.50207437 0.105460164,5.3713279 C-0.019369295,5.26667107 -0.0357224462,5.08063568 0.0689343781,4.95580622 C0.0800180229,4.9425862 0.0922401431,4.93036408 0.105460164,4.91928044 L2.80135887,2.65904315 C2.84012885,2.62653845 2.88330784,2.60211471 2.92870361,2.5857719 L0.500039468,0.550107318 C0.375210009,0.445450494 0.358856858,0.259415104 0.463513682,0.134585645 C0.474597327,0.121365625 0.486819447,0.109143504 0.500039468,0.0980598596 C0.655987371,-0.0326866199 0.883271307,-0.0326866199 1.03921921,0.0980598596 Z",
    stroke: "url(#i11)",
    strokeWidth: 0.9,
    fill: "none",
    strokeLinejoin: "round"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGift6);
export default __webpack_public_path__ + "static/media/icGift6.b8c4ff72124dea5f9a76e98d3ef2d837.svg";
export { ForwardRef as ReactComponent };